import type { HbBidderConfig } from '../types'

export const EQUATIV: HbBidderConfig = {
    bidder: 'equativ',
    params: {
        networkId: 5900,
        siteId: 764525,
        pageId: 2169617,
        formatId: 153304,
    },
}
